export const SET_ERROR_COMPANYCUSTOMER_STATE = 'SET_ERROR_COMPANYCUSTOMER_STATE';

export default function setErrorCompanyCustomer(payload) {
  return {
    type: SET_ERROR_COMPANYCUSTOMER_STATE,
    payload,
  };
}
